import { css } from "@emotion/react";
import { Suspense, useState } from "react";
import { FaArrowRight, FaHandPointRight } from "react-icons/fa";
import * as ReactModal from "react-modal";
import { getHostMeta } from ".";
import UnknownHost from "./UnknownHost";
import UnsupportedHost from "./UnsupportedHost";

const modalStyles = {
    content: {
        top: "10%",
        left: "10%",
        right: "10%",
        bottom: "auto"
    }
};

export default function HostSpecificInstructions({ host }) {
    const meta = getHostMeta(host);

    const [modalOpen, setModalOpen] = useState(false);
    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    if (!host || meta.supported == "UNKNOWN") return <UnknownHost />;

    if (meta.supported != "YES") return <UnsupportedHost name={meta.name} />;

    return (
        <>
            <p>
                <a
                    href="#"
                    onClick={event => {
                        event.preventDefault();
                        openModal();
                    }}
                >
                    <FaHandPointRight
                        style={{ fontSize: "1.5em", fill: "orange", verticalAlign: "middle" }}
                    />{" "}
                    Here's how to set up Podtrac measurement on <b>{meta.name}</b>
                </a>.
            </p>
            <ReactModal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                style={modalStyles}
                contentLabel="How to Set Up Podtrac Measurement"
            >
                <div
                    css={css`
                        display: flex;
                        align-items: center;
                        & > h1 {
                            margin: 0.5rem 0;
                            font-size: 1.5rem;
                            font-weight: 500;
                            color: #000;
                            & span {
                                opacity: 0.65;
                                display: inline-block;
                                font-size: 0.8em;
                                margin-left: 1em;
                                text-transform: uppercase;
                            }
                            & strong {
                                display: inline-block;
                                margin-left: 0.5em;
                            }
                        }
                        margin-bottom: 1rem;
                    `}
                >
                    <h1
                        css={css`
                            flex: 1;
                        `}
                    >
                        How to Set Up Podtrac Measurement <span>on {meta.name}</span>
                    </h1>
                    <div
                        onClick={closeModal}
                        css={css`
                            font-size: 1.5rem;
                            font-weight: 500;
                            color: #999;
                            cursor: pointer;
                            &:hover {
                                color: #000;
                            }
                        `}
                    >
                        ×
                    </div>
                </div>
                <div
                    css={css`
                        max-height: 70vh;
                        overflow: auto;
                        padding-right: 0.5rem;
                    `}
                >
                    <Suspense fallback="Loading...">
                        {meta.instructions ? <meta.instructions host={host} /> : null}
                    </Suspense>
                </div>
            </ReactModal>
        </>
    );
}
